import { useEffect, useRef, useState } from "react";
import styles from "./style/TagColorPicker.module.scss";

const COLOR_OPTIONS = [
  { bg: "#FFE4E4", text: "#FE7F7F", theme: "red" },
  { bg: "#FFE9F1", text: "#E775A7", theme: "pink" },
  { bg: "#FFEDDC", text: "#DB8330", theme: "orange" },
  { bg: "#FFFCCE", text: "#EABE1F", theme: "yellow" },
  { bg: "#E6F9DB", text: "#71AF4D", theme: "green" },
  { bg: "#E7F4FF", text: "#409BF0", theme: "blue" },
  { bg: "#E9EEFF", text: "#4868D9", theme: "indigo" },
  { bg: "#F2E8FF", text: "#7B5BFD", theme: "purple" },
  { bg: "#FAEADF", text: "#D0905E", theme: "brown" },
  { bg: "#F5F5F5", text: "#797979", theme: "gray" },
];

const TagColorPicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const safeValue = value || COLOR_OPTIONS[0];

  useEffect(() => {
    if (!open) return;
    const onDocMouseDown = (e) => {
      if (!wrapRef.current) return;
      if (wrapRef.current.contains(e.target)) return;
      setOpen(false);
    };

    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, [open]);

  const toggle = () => setOpen((v) => !v);

  const pick = (opt) => {
    onChange(opt);
    setOpen(false);
  };

  return (
    <div className={styles.wrap} ref={wrapRef}>
      <button
        type="button"
        className={`${styles.buttonWrap} ${open ? styles.buttonWrapOpen : ""}`}
        onClick={toggle}
        aria-label="選擇標籤顏色"
        aria-expanded={open}
      >
        <span
          className={styles.buttonDot}
          style={{ backgroundColor: safeValue.text }}
          aria-hidden
        />
      </button>

      {open ? (
        <div
          className={styles.popover}
          role="dialog"
          aria-label="標籤顏色選擇器"
        >
          <div className={styles.grid}>
            {COLOR_OPTIONS.map((opt) => {
              const label = `${opt.bg}/${opt.text}`;
              const selected =
                opt.bg.toLowerCase() === String(safeValue.bg).toLowerCase() &&
                opt.text.toLowerCase() === String(safeValue.text).toLowerCase();

              return (
                <button
                  key={label}
                  type="button"
                  className={`${styles.option} ${selected ? styles.optionSelected : ""}`}
                  style={{ backgroundColor: opt.text }}
                  onClick={() => pick(opt)}
                  aria-label={`選擇 ${label}`}
                ></button>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default TagColorPicker;
